import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

export default function initNavAnchorSection() {

    const updateable = new Array();

    const init = () => {
        gsap.registerPlugin(ScrollTrigger);
        gsap.registerPlugin(ScrollToPlugin);


        document.querySelectorAll('.nav-anchorlinks-section').forEach((anchorLinksSection) => {
            
            const mobileToggleTitle = anchorLinksSection.querySelector('.mobile-toggle .current-title');
            const mobileToggleButton = anchorLinksSection.querySelector('.mobile-toggle');
            const navColumn = anchorLinksSection.querySelector('.anchorlinks-col');
            const navLinksContainer = navColumn.querySelector('.anchors-nav');
            const navLinks = anchorLinksSection.querySelectorAll('.anchors-nav__link');
            const toggleSection = document.querySelector('.page-toggle-section');
            
            let elemSibling = anchorLinksSection.previousElementSibling;
            let siblingIsToggleSection = false;

            if (elemSibling && elemSibling.tagName === 'STYLE') {
                elemSibling = elemSibling.previousElementSibling;
            }

            if( toggleSection && elemSibling.childNodes[0] === toggleSection ) {
                siblingIsToggleSection = true;
            }

            const getTopSectionBounds = () => {
        
                if (toggleYHeight > 400) return 0;
                return toggleSection.getBoundingClientRect().top + toggleSection.offsetHeight;
            };

            const options = {
                trigger: anchorLinksSection,
                endTrigger: document.querySelector('body'),
                start: () => {
                    let topMenu = document.querySelector('header.header');

                    if (siblingIsToggleSection) {  
                        const rowCollapsed = toggleSection.querySelector('.row.collapsed');
                        return `top top+=${ topMenu.offsetHeight + rowCollapsed.offsetHeight + 20 }`;
                    }

                    return `top top+=${topMenu.offsetHeight}`
                },
                end: 'bottom top',
                fastScrollEnd: true,
                //markers: { startColor: "magenta", endColor: "blue", fontSize: "18px", fontWeight: "bold", indent: 20 },
                pin: true,
                pinSpacing: false,
                invalidateOnRefresh: true,
            };

            if (siblingIsToggleSection ) options.pinContainer = toggleSection;
            
            ScrollTrigger.create( options);

            const anchorLinks = anchorLinksSection.querySelectorAll('.anchors-nav .anchors-nav__link');
            anchorLinks.forEach((anchorLink) => {
            
                const target = document.querySelector( anchorLink.getAttribute('href') );
                if( !target ) return;

                anchorLink.addEventListener('click', (e) => {
                    const anchorLinkSectionHeight = anchorLinksSection.offsetHeight;
                    const toggleSectionHeight = toggleSection ? toggleSection.querySelector('.row.collapsed').offsetHeight : 0;
                    const topMenuY = document.querySelector('header.header').offsetHeight;
                    const offsetY = topMenuY + anchorLinkSectionHeight + toggleSectionHeight;

                    e.preventDefault();
                    if (target) {
                        gsap.to(window, { duration: 1, ease: "expo.inOut", scrollTo: { y: target, offsetY: offsetY } });
                    }
                });


                // use scrolltrigger to add "active" class to anchorLink when target is in view
                const st = ScrollTrigger.create({
                    trigger: target,
                    start: "top 50%",
                    end: "bottom 50%",
                    onEnter: () => {
                        anchorLink.classList.add('anchor-active');
                        if (mobileToggleTitle) mobileToggleTitle.textContent = anchorLink.textContent;
                    },
                    onEnterBack: () => {
                        anchorLink.classList.add('anchor-active');
                        if (mobileToggleTitle) mobileToggleTitle.textContent = anchorLink.textContent;
                    },
                    onLeave: () => {
                        anchorLink.classList.remove('anchor-active');
                    },
                    onLeaveBack: () => {
                        anchorLink.classList.remove('anchor-active');
                    },
                    
                    //markers: { startColor: "green", endColor: "yellow", fontSize: "18px", fontWeight: "bold", indent: 20 },
                });                

                updateable.push({ target: target, trigger: st } );
            } );

            // default value
            mobileToggleTitle.textContent = anchorLinks[0].textContent;
            

            // mobile toggle ------------------------
            if (mobileToggleButton) {
                mobileToggleButton.addEventListener('click', () => {
                    mobileToggleButton.classList.toggle('is-open');
                    navColumn.classList.toggle('is-open');
                });
            }

            navLinks.forEach((navLink) => {
                navLink.addEventListener('click', () => {
                    if (mobileToggleButton) {
                        mobileToggleButton.classList.remove('is-open');
                        navColumn.classList.remove('is-open');
                    }
                });
            });

            const navLinksContainerWidth = Array.from(navLinksContainer.children).reduce((totalWidth, child) => {
                return totalWidth + child.offsetWidth;
            }, 0);

            
            if (navColumn.offsetWidth < navLinksContainerWidth) {
                navLinksContainer.classList.add('is-scrollable');
            } else {
                navLinksContainer.classList.remove('is-scrollable');
            }


            if (toggleSection) {
                const toggleButtons = toggleSection.querySelectorAll('.button_type-primary');
                toggleButtons.forEach((button) => {
                    button.addEventListener('click', () => {
                        updateable.forEach((item) => {
                            setTimeout(item.trigger.refresh, 200);
                        });
                    });
                });
            }

        });


    }


	init();

}
